import DiscordIcon from "../../../../ui/svg/common/social-icons/discord";
import FacebookIcon from "../../../../ui/svg/common/social-icons/facebook";
import InstagramIcon from "../../../../ui/svg/common/social-icons/instagram";
import LinkedinIcon from "../../../../ui/svg/common/social-icons/linkedin";
import PinterestIcon from "../../../../ui/svg/common/social-icons/pinterest";
import RedditIcon from "../../../../ui/svg/common/social-icons/reddit";
import RumbleIcon from "../../../../ui/svg/common/social-icons/rumble";
import SnapchatIcon from "../../../../ui/svg/common/social-icons/snapchat";
import SoundbetterIcon from "../../../../ui/svg/common/social-icons/soundbetter";
import SoundcloudIcon from "../../../../ui/svg/common/social-icons/soundcloud";
import SpotifyIcon from "../../../../ui/svg/common/social-icons/spotify";
import TelegramIcon from "../../../../ui/svg/common/social-icons/telegram";
import TikTokIcon from "../../../../ui/svg/common/social-icons/tiktok";
import TwitchIcon from "../../../../ui/svg/common/social-icons/twitch";
import TwitterIcon from "../../../../ui/svg/common/social-icons/twitter";
import VimeoIcon from "../../../../ui/svg/common/social-icons/vimeo";
import YouTubeIcon from "../../../../ui/svg/common/social-icons/youtube";
import React from "react";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";
import {ModeratorEntityTypeEnum} from "../common-enum";
import { ProfileDM, SiteDM} from "../interfaces";
import XIcon from "../../../../ui/svg/common/social-icons/x";

export const sleep = (ms = 0) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};
export const getSocialIconByDomainName =(domainName:string, iconSize:string) => {
    let svgComponent = <>{domainName}</>;
    switch(domainName.toLowerCase()){
        case 'discord':{
            svgComponent = <DiscordIcon title={"follow on Discord"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'facebook':{
            svgComponent = <FacebookIcon title={"follow on Facebook"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'instagram':{
            svgComponent = <InstagramIcon title={"follow on Instagram"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'linkedin':{
            svgComponent = <LinkedinIcon title={"follow on Linkedin"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'pinterest':{
            svgComponent = <PinterestIcon title={"follow on Pinterest"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'reddit':{
            svgComponent = <RedditIcon title={"follow on Reddit"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'rumble':{
            svgComponent = <RumbleIcon title={"follow on Rumble"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'snapchat':{
            svgComponent = <SnapchatIcon title={"follow on Snapchat"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'soundbetter':{
            svgComponent = <SoundbetterIcon title={"follow on Soundbetter"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'soundcloud':{
            svgComponent = <SoundcloudIcon title={"follow on Soundcloud"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'spotify':{
            svgComponent = <SpotifyIcon title={"follow on Spotify"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'telegram':{
            svgComponent = <TelegramIcon title={"follow on Telegram"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'tiktok':{
            svgComponent = <TikTokIcon title={"follow on TikTok"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'twitch':{
            svgComponent = <TwitchIcon title={"follow on Twitch"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'x':{
            svgComponent = <XIcon title={"follow on Twitter"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'twitter':{
            svgComponent = <TwitterIcon title={"follow on Twitter"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'vimeo':{
            svgComponent = <VimeoIcon title={"follow on Vimeo"} width={iconSize} height={iconSize} />;
            break;
        }
        case 'youtube':{
            svgComponent = <YouTubeIcon title={"follow on YouTube"} width={iconSize} height={iconSize} />;
            break;
        }
    }

    return svgComponent;
}
export const getEpochFromDate = (date : Date) => {
    return new Date(date) !== null ? new Date(date).getTime() : 0;
}
export const clickProfileReportAnIssue = (profile : ProfileDM) => {
    sendGAEvent("Click","Report an issue Profile: " + profile.publicName );
    window.location.href = "/studioverse/report-an-issue/"+ModeratorEntityTypeEnum.Profile+"/"+ profile.prfUserGUID;
}
export const clickProfileSite = (site : SiteDM) => {
    sendGAEvent("Click","Social: " + site.domainName );
    window.open(site.siteURL);
}
export const onClickProfile = (profile : ProfileDM) => {
    sendGAEvent("SV Widget","Widget Profile: " + profile.handle);
    window.location.href = "/studioverse/creator/" + profile.handle;
}